import { SCOPE_TYPE } from "@model";

export function hasVfaAdaptiveTracking(scopeList: string[] | null | undefined): boolean {
  return Boolean(scopeList?.includes(SCOPE_TYPE.vfaAdaptiveTracking));
}
